import React from 'react'

const Handmade: React.FC = () => {
  return (
    <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_336_12803)">
        <path
          d="M2.8999 7.00004H2.2749V1.75004C2.2749 1.10546 2.83428 0.583374 3.5249 0.583374C4.21553 0.583374 4.7749 1.10546 4.7749 1.75004V6.70837H4.1499V1.75004C4.1499 1.42921 3.86865 1.16671 3.5249 1.16671C3.18115 1.16671 2.8999 1.42921 2.8999 1.75004V7.00004Z"
          fill="currentColor"
        />
        <path
          d="M6.6499 6.125H6.0249V1.16667C6.0249 0.845833 5.74365 0.583333 5.3999 0.583333C5.05615 0.583333 4.7749 0.845833 4.7749 1.16667V6.125H4.1499V1.16667C4.1499 0.522083 4.70928 0 5.3999 0C6.09053 0 6.6499 0.522083 6.6499 1.16667V6.125Z"
          fill="currentColor"
        />
        <path
          d="M8.5249 6.70837H7.8999V1.75004C7.8999 1.42921 7.61865 1.16671 7.2749 1.16671C6.93115 1.16671 6.6499 1.42921 6.6499 1.75004V6.70837H6.0249V1.75004C6.0249 1.10546 6.58428 0.583374 7.2749 0.583374C7.96553 0.583374 8.5249 1.10546 8.5249 1.75004V6.70837Z"
          fill="currentColor"
        />
        <path
          d="M9.4624 14H8.8374V13.0287L8.8999 12.95C9.46553 12.247 9.7749 11.3779 9.7749 10.5V3.20829C9.7749 2.88746 9.49365 2.62496 9.1499 2.62496C8.80615 2.62496 8.5249 2.88746 8.5249 3.20829V5.54163H7.8999V3.20829C7.8999 2.56371 8.45928 2.04163 9.1499 2.04163C9.84053 2.04163 10.3999 2.56371 10.3999 3.20829V10.5C10.3999 11.4712 10.0687 12.4308 9.4624 13.2212V14Z"
          fill="currentColor"
        />
        <path
          d="M3.2124 14H2.5874C2.5874 13.6792 2.47803 13.3846 2.25928 13.1221L1.45303 12.1567C0.774902 11.3429 0.399902 10.325 0.399902 9.2925V4.375H1.3374C2.1999 4.375 2.8999 5.02833 2.8999 5.83333V8.28625L2.18428 8.95417L1.74365 8.54292L2.27803 8.04417V5.83042C2.27803 5.34917 1.85615 4.95542 1.34053 4.95542H1.02803V9.28667C1.02803 10.1908 1.35615 11.0804 1.9499 11.7921L2.75615 12.7575C3.05615 13.1192 3.21553 13.5479 3.21553 13.9942L3.2124 14Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_336_12803">
          <rect width="10" height="14" fill="white" transform="translate(0.399902)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Handmade
